import { render, staticRenderFns } from "./Dataset_v1.vue?vue&type=template&id=207cd060&scoped=true&"
import script from "./Dataset_v1.vue?vue&type=script&lang=js&"
export * from "./Dataset_v1.vue?vue&type=script&lang=js&"
import style0 from "./Dataset_v1.vue?vue&type=style&index=0&id=207cd060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207cd060",
  null
  
)

export default component.exports